import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { muiTheme, muiThemeDark } from "./muiTheme";

/**
 * Color mode (light/dark) for WhatsPRO.
 * - Toggles the `dark` class on <html> so all CSS-variable tokens flip.
 * - Swaps the MUI theme (light/dark) for MUI components.
 * - Persists the choice in localStorage.
 */
const ColorModeContext = createContext({ mode: "light", toggle: () => {} });

export const useColorMode = () => useContext(ColorModeContext);

const getInitial = () => {
  try {
    const saved = localStorage.getItem("wp-theme");
    if (saved === "dark" || saved === "light") return saved;
  } catch (e) {}
  return "light";
};

export function ColorModeProvider({ children }) {
  const [mode, setMode] = useState(getInitial);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", mode === "dark");
    root.style.colorScheme = mode;
    try {
      localStorage.setItem("wp-theme", mode);
    } catch (e) {}
  }, [mode]);

  const toggle = useCallback(() => setMode((m) => (m === "dark" ? "light" : "dark")), []);
  const value = useMemo(() => ({ mode, toggle }), [mode, toggle]);

  return (
    <ColorModeContext.Provider value={value}>
      <ThemeProvider theme={mode === "dark" ? muiThemeDark : muiTheme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default ColorModeContext;
